import React from "react";
import { Typography, Box, IconButton, Stack, Link } from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import MailIcon from "@mui/icons-material/Mail";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import Whatsapp from "./whatsapp";

const importantLinks = [
  { name: "Etusivu", link: "/" },
  { name: "Meistä", link: "/meista" },
  { name: "Lahjoita ja Myydä", link: "/lahjoita-ja-myyda" },
  { name: "Tuotteet", link: "/products" },
  { name: "Ostoehdot", link: "/ostoehdot" },
  { name: "Palvelut", link: "/blogi" },
];

const infos = [
  {
    icon: <PhoneIcon />,
    description: "041 312 4969",
    href: "tel:0413124969",
  },
  {
    icon: <MailIcon />,
    description: "info@m2tahtioy.fi",
    href: "mailto:info@m2tahtioy.fi",
  },
  {
    icon: <LocationOnIcon />,
    description: "Niittyläntie 3, 00620 Helsinki",
    href: "https://www.google.com/maps/place/Niittyläntie+3,+00620+Helsinki",
  },
];

function Footer() {
  return (
    <>
      <Whatsapp />
      <Box 
        mt='3vh'  
        minHeight="40vh" 
        width="100%" 
        sx={{
          backgroundColor: "#263238", 
          display: "flex", 
          justifyContent: "center", 
          alignItems: "center", // Tüm içeriği dikey ve yatay ortalar
        }}
      >
        <Stack 
          direction={{ xs: "column", md: "row" }} 
          spacing={2} 
          justifyContent={{xs:"center",md:'space-around'}} 
          alignItems="center"
          sx={{ width: {xs:"100%",md:'80%'}, py: 3 }} // Yüksekliği belirleyerek ortalamayı daha sağlam yapar
        >
          
          {/* LOGO ve ŞİRKET ADI */}
          <Box 
            display="flex" 
            flexDirection="column"
            alignItems="center" 
            justifyContent="center"
            width={{ xs: "80%", md: "30%" }} 
            textAlign="center"
          >
            <Stack direction="row" spacing={1} alignItems="center">
              <img src={`${process.env.PUBLIC_URL}/logo_5.png`} width="50%" />
              <Box>
                <Typography variant="h6" color="white">
                  Ehankki Kaluste
                </Typography>
                <Typography style={{ color: "#8f9296" }} variant="body2">
                  Luotettava ja Ladukas
                </Typography>
              </Box>
            </Stack>
          </Box>

          {/* ÖNEMLİ LİNKLER */}
          <Box width={{xs:'100%',md:'30%'}} >
          <Stack direction='row' justifyContent={{md:'center'}}>
          <Stack
           
            display={{md:'none'}}
            paddingLeft='3%'
            direction='column'
            width={{ xs: "100%", md: "30%" }}
            justifyContent='center'
            spacing={2}
          >
          <Typography variant='h6' sx={{color:'white'}}>Aukioloajat</Typography>
          <Typography variant='h6'   sx={{color:'white'}}>ma - la : 11:00 - 18:00</Typography>
          <Typography variant='h6' sx={{color:'white'}}>su: 12:00 - 17:00</Typography>
          </Stack>
          <Stack
            direction='column'
            alignItems='center' 
            justifyContent='space-around'
            width={{ xs: "100%", md: "30%" }}
            textAlign="center"
            spacing={3}
           
          >
            {importantLinks.map((link, index) => (
              <Link key={index} href={link.link} sx={{ textDecoration: "none", color: "white", "&:hover": { color: "#ffcc00" } }}>
                <Typography variant="body1">{link.name}</Typography>
              </Link>
            ))}
          </Stack>
          </Stack>
          </Box>
          {/* İLETİŞİM BİLGİLERİ */}
          <Stack
            
            direction='column'
            alignItems={{xs:'center' , md: 'flex-end'}}
            justifyContent='center'
            width={{ xs: "100%", md: "30%" }}
            textAlign="center"
            spacing={2}
          >
            {infos.map((info, index) => (
              <Box display="flex" alignItems="center" key={index}>
                <IconButton
                  component="a"
                  href={info.href}
                  target="_blank"
                  sx={{ color:'orangered' }}
                >
                  {info.icon}
                </IconButton>
                <Typography variant="body1" sx={{ ml: 1, color: "white" }}>
                  {info.description}
                </Typography>
              </Box>
            ))}
          </Stack>

        </Stack>
      </Box>
    </>
  );
}

export default Footer;
